/**
 * Indicate if the header should have fill color or if should be transparent on page load
 * Need to be rewritten to non-js
 */
function pageHeaderDetection() {
    // find the first section
    const firstSection = document.getElementById('section-number-1');
    // check if it has background color or background image
    const hasBgImg = firstSection.classList.contains('section--bg-img');
    const hasPageHeader = firstSection.classList.contains('s-page-header');
    const hasPageHeaderSimple = firstSection.classList.contains('s-page-header-simple');

    const whiteBg = firstSection.classList.contains('white-background');
    const body = document.getElementsByTagName('body')[0];

    if (whiteBg) {
        body.classList.add('js-no-page-header');
    }

    // keep the site header transparent
    if (hasBgImg || hasPageHeader || hasPageHeaderSimple) {
        return;
    }

    // make site header white
    /* TODO: replace .js-no-page-header class with something js-header-white or js-header-fill-color */
    body.classList.add('js-no-page-header');

}

function loadSlider(slider) {
    let s = slider;
    let wrap = s.querySelector('.s-slider-final__wrap');
    let lastSlides = s.querySelectorAll('.s-slider-final__slide');
    lastSlides.forEach((el) => {
        el.classList.add('original-slide');
    });
    let clonedElements = Array.from(lastSlides, (el) => el.cloneNode(true));
    clonedElements.reverse();

    clonedElements.forEach((el) => {
        el.classList.remove('original-slide');
        el.classList.add('clone', 'initial-clone');
    });

    wrap.prepend(...clonedElements.reverse());

    let firstSlide = wrap.querySelectorAll('.initial-clone');
    firstSlide = firstSlide[firstSlide.length - 1].nextElementSibling;
    console.log(firstSlide);
    let offset = firstSlide.getBoundingClientRect().left + window.pageXOffset - wrap.getBoundingClientRect().left - window.pageXOffset;
    firstSlide.classList.add('active');

    wrap.style.marginLeft = -offset + 'px';
}

window.addEventListener('load', function () {
    pageHeaderDetection();
    document.body.classList.remove('preload');
    /* get all section with background color */
    const bgColorSections = document.querySelectorAll('.section--bg-color');

    /* do something with each found section */
    bgColorSections.forEach(function (section) {
        const sectionBgColor = window.getComputedStyle(section).getPropertyValue('background-color'),
            prevSection = section.previousElementSibling,
            nextSection = section.nextElementSibling;

        let prevSectionBgColor = null,
            nextSectionBgColor = null;

        if (prevSection !== null) {
            prevSectionBgColor = window.getComputedStyle(prevSection).getPropertyValue('background-color');
        }

        if (nextSection !== null) {
            nextSectionBgColor = window.getComputedStyle(nextSection).getPropertyValue('background-color');
        }

        /* if the current section has the same background color as prev section,
            reduce its top padding */
        if (null !== prevSection && sectionBgColor === prevSectionBgColor) {
            /* console.log('a section with bg-color before'); */
            section.classList.add('section--top-p-small');
        }

        /* if the current section has the same background color as next section,
            reduce its bottom padding */
        if (null !== nextSection && sectionBgColor === nextSectionBgColor) {
            /* console.log('a section with bg-color after'); */
            section.classList.add('section--bottom-p-small');
        }
    });

    const blocks = document.querySelectorAll('[class*=is-style-]');
    blocks.forEach(function (item) {
        let classList = item.className;
        let newClass = classList.split('is-style-')[1];

        console.log(classList, newClass);

        if (typeof newClass != 'undefined' && newClass != null && !item.classList.contains(newClass) && !item.classList.contains('wp-block-button')) {
            item.classList.add(newClass);
        } else if (item.classList.contains('wp-block-button')) {
            item.firstChild.classList.remove('wp-block-button__link');
            item.firstChild.classList.add('button', newClass);
        }
    });

    document.querySelectorAll('.s-slider-final').forEach(function (slider) {
        loadSlider(slider);
    });

    var videos = document.getElementsByTagName('video');

    // Create a new IntersectionObserver instance
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                // If the video is entering the viewport, start playing it
                entry.target.play();
            } else {
                // If the video is leaving the viewport, pause it and save the current time
                entry.target.pause();
                entry.target.dataset.currentTime = entry.target.currentTime;
            }
        });
    });

    // Loop over each video element
    for (var i = 0; i < videos.length; i++) {
        // console.log(videos);
        // Check if the video element has a lazy-src attribute
        if (videos[i].querySelector('source').hasAttribute('lazy-src')) {
            // console.log(videos[i].querySelector('source'));
            // Set the src attribute to an empty string to prevent the video from loading automatically
            videos[i].querySelector('source').setAttribute('src', videos[i].querySelector('source').getAttribute('lazy-src'));
            videos[i].load();
            // videos[i].setAttribute('autoplay');
            // Add the video element to the IntersectionObserver instance
            observer.observe(videos[i]);

            // Add an event listener to the video element to restore the current time when resuming playback
            videos[i].addEventListener('playing', function () {
                if (this.dataset.currentTime) {
                    this.currentTime = parseFloat(this.dataset.currentTime);
                    delete this.dataset.currentTime;
                }
            });
        }
    }
});

require('./routes/other/animations');



// WEBPACK FOOTER //
// resources/assets/scripts/critical.js